
import { defineComponent } from 'vue'
import { AuthPasswordResetConfirmation } from '@bd/components'

export default defineComponent({
  name: 'PasswordResetConfirmation',
  components: { AuthPasswordResetConfirmation },
})
